<!--
  dropIn.vue
  Airwallex Payment Demo - Vue.  Created by Jessica Zhou and Josie Ku.

  airwallex-payment-elements dropIn element integration in Vue.
  Comments with "Example" demonstrate how states can be integrated
  with the element, they can be removed.

  Detailed guidance here: https://github.com/airwallex/airwallex-payment-demo/blob/master/docs/dropin.md
-->
<template>
    <div class="dropin-box">
      <!-- <h2>DropIn integration</h2> -->
      <!-- Example below: loading state when element is not yet mounted -->
      <p id="loading">Loading...</p>
      <!-- Example: response message container -->
      <p id="error" style="display: none" />
      <!-- 
        STEP #3: Add an empty container for the dropIn element to be injected into 
        - Ensure this is the only element in your document with this id, otherwise the element may fail to mount.
      -->
      <div ref="dropInRef" id="dropIn"/>
    </div>
</template>

<script setup>
import { XlDialog, XlMessage } from "@shining3d/ui-components";
import { ref, onMounted, onBeforeUnmount, nextTick, watch, computed} from "vue";
// STEP #1: Import airwallex-payment-elements package
import { createElement, loadAirwallex } from 'airwallex-payment-elements';
import creditCardApi from '../../../api/creditCard'
import { useLang } from "@shining3d/common-module/utils/lang.js";
import router from "@/router";
import Bus from '../../../utils/bus.js';
import { VueCookieNext } from 'vue-cookie-next';
const route = computed(()=>router.currentRoute.value);
const { $t } = useLang("@shining3d/xl-design-order");

const props = defineProps({
  creditCardData: {
    type: Object
  }
})
// Enter your Payment Intent secret keys here
// More on getting these secrets: https://www.airwallex.com/docs/api#/Payment_Acceptance/Payment_Intents/Intro
const intentId = ref('');
const clientSecret = ref('');
const dropInRef = ref()
const currency = ref('');
const env = ref('');
// const visible = ref(false);
const showDiv = ref(false);
const locale = computed(() => VueCookieNext.getCookie('lang')?.split('-')?.[0]);
const emits = defineEmits(['getDetail', 'changePayLoading', 'updateScrollbar', 'paySucc'])
const show = (intentIdData, clientSecretData, currencyData, envData) => {
  intentId.value = intentIdData;
  clientSecret.value = clientSecretData;
  currency.value = currencyData;
  env.value = envData;
  // visible.value = true;
  setTimeout(() => {
    nextTick(() => {
      init();
      // onReady();
    })
  }, 1000);

}
// 关闭dialog
// const closeDialog = () => {
//   visible.value = false;
//   emits( 'changePayLoading', false );
// }
const init = () => {
  const domElement = document.getElementById('dropIn');
  domElement.addEventListener('onReady', onReady);
  domElement.addEventListener('onSuccess', onSuccess);
  domElement.addEventListener('onError', onError);
  // STEP #2: Initialize Airwallex on mount with the appropriate production environment and other configurations
  loadAirwallex({
    env: props.creditCardData?.envData, // Can choose other production environments, 'staging | 'demo' | 'prod'
    origin: window.location.origin, // Setup your event target to receive the browser events message
    locale: locale.value || 'en',// language
    // For more detailed documentation at https://github.com/airwallex/airwallex-payment-demo/tree/master/docs#loadAirwallex
  }).then(() => {
    // STEP #4: Create the drop-in element
    const element = createElement('dropIn', {
      // Required, dropIn use intent Id, clientSecret and currency to prepare checkout
      intent_id: props.creditCardData?.intentIdData,
      client_secret: props.creditCardData?.clientSecretData,
      currency: props.creditCardData?.currencyData,
      theme: {
        palette: {
          primary: '#5587FF', // brand color, the default value is #612FFF
        },
      }
    });
    // STEP #5: Mount the drop-in element to the empty container created previously
    element.mount('dropIn'); // This 'dropIn' id MUST MATCH the id on your empty container created in Step 3
  });
};

// STEP #6: Add an event listener to handle events when the element is mounted
const onReady = (event) => {
  /**
   * ... Handle event on element mount
   */
  document.getElementById('loading').style.display = 'none'; // Example: hide loading state when element is mounted
  document.getElementById('dropIn').style.display = 'block'; // Example: show element when mounted
  setTimeout(() => {
    nextTick(() => {
      emits('updateScrollbar');
    })
  }, 300);
};

// STEP #7: Add an event listener to handle events when the payment is successful.
const onSuccess = (event) => {
  /**
   * ... Handle events on success
   */
  // visible.value = false;
  // closeDialog();
  let cardInfo = {}
  if( event?.detail?.intent?.latest_payment_attempt?.payment_method?.type === 'card' ) {
    cardInfo = {
      cardType: event.detail.intent.latest_payment_attempt.payment_method?.card?.card_type,
      brand: event.detail.intent.latest_payment_attempt.payment_method?.card?.brand,
      last4: event.detail.intent.latest_payment_attempt.payment_method?.card?.last4,
    }
  } else {
    cardInfo = undefined;
  }
  creditCardApi.paySuccess({
    card: cardInfo,
    type: event?.detail?.intent?.latest_payment_attempt?.payment_method?.type,
    platform: window.app?.entryName || 'dental',
    paymentIntentID: event.detail?.intent?.id,
    orderID: event.detail?.intent?.merchant_order_id,
  }).then((res) => {
    if( res && res.status === 'success' ){
      // emits('getDetail');
      XlMessage({ type: 'success', message: $t('design.creditCard.PaymentSuccess') || '支付成功' });
      Bus.$emit( 'updateOrderList' )
      emits('paySucc');
      //跳转到数据下载
      // router.push({name: 'orderDetail', params: { id: route.value?.params?.id }, query: { type: 'dataDownload' }});
    }
  })
};

// STEP #8: Add an event listener to handle events when the payment has failed.
const onError = (event) => {
  /**
   * ... Handle event on error
   */
  // visible.value = false;
  // closeDialog();
  XlMessage({ type: 'error', message: $t('design.creditCard.PaymentFail') || '支付失败' });
  const { error } = event?.detail;
  document.getElementById('error').style.display = 'block'; // Example: show error block
  document.getElementById('error').innerHTML = error?.message; // Example: set error message
  console.error('There was an error', error);
};
// watch(()=> dropInRef.value, (val) => {
//   if( val){
//     nextTick(() => {
//       init();
//       const domElement = document.getElementById('dropIn');
//       if( domElement){
//         debugger;
//         domElement.addEventListener('onReady', onReady);
//         domElement.addEventListener('onSuccess', onSuccess);
//         domElement.addEventListener('onError', onError);
//       }
//     })
//   }
// },{deep: true, immediate: true})

onMounted(() => {
})

onBeforeUnmount(() => {
  const domElement = document.getElementById('dropIn');
    // Be sure to clean up event listeners when component unmounts
    if (domElement) {
      domElement?.removeEventListener('onReady', onReady);
      domElement?.removeEventListener('onSuccess', onSuccess);
      domElement?.removeEventListener('onError', onError);
    }
})
defineExpose({show, showDiv, init})
</script>

<style lang="scss" scoped>
/* Custom styling for the element */
#dropIn {
  width: 696px;
  // margin: 48px auto;
}
.dropin-box{
  min-width: 652px;
}
</style>
